import { Link, useLocation } from "react-router-dom";
import logo from "@/assets/EMA-KO-Logo.png";

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  const location = useLocation();
  const isHomepage = location.pathname === "/";

  return (
    <footer className="bg-black py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center md:justify-between gap-6">
          <Link to="/" className="md:flex-shrink-0">
            <img src={logo} alt="Evolve Media Agency" className="h-6 opacity-70" />
          </Link>

          <div className="flex flex-wrap gap-6 justify-center">
            <Link to="/video-portfolio" onClick={() => window.scrollTo(0, 0)} className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              Video Portfolio
            </Link>
            <Link to="/product-photos" onClick={() => window.scrollTo(0, 0)} className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              Photo Portfolio
            </Link>
            <Link to="/ai" onClick={() => window.scrollTo(0, 0)} className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              AI Shoot
            </Link>
            <Link to="/blog" onClick={() => window.scrollTo(0, 0)} className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              Blog
            </Link>
            <a href="https://evolvemedia.agency/pricing" className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              Pricing
            </a>
            <a href="https://calendly.com/evolvemedia/amz-30-min" target="_blank" rel="noopener noreferrer" className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              Contact
            </a>
          </div>

          <div className="flex gap-6 md:flex-shrink-0">
            <Link to="/sitemap" onClick={() => window.scrollTo(0, 0)} className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm">
              Sitemap
            </Link>
            <a
              href="https://evolveamz.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm"
            >
              Privacy Policy
            </a>
          </div>
        </div>

        {/* Evolve Media Network backlink row */}
        <div className="border-t border-section-dark-foreground/10 mt-6 pt-6">
          <p className="text-center text-section-dark-foreground/60 text-xs uppercase tracking-wider mb-3 font-semibold">
            Part of the Evolve Media Network
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            <a
              href="https://evolveamz.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm"
            >
              EvolveAMZ.com — Full-service Amazon agency
            </a>
            <a
              href="https://evolvemedia.agency/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-section-dark-foreground/70 hover:text-cta-blue transition text-sm"
            >
              EvolveMedia.Agency — Creative network
            </a>
          </div>
        </div>

        <p className="text-section-dark-foreground/50 text-sm text-center mt-4">
          © {new Date().getFullYear()} Evolve Media Agency. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
